/*
	Сохраняем параметры фильтрации кампаний в localStorage
*/

export const setFilterParameters = (filter: string) => {
	localStorage.setItem("campaignsFilter", filter);
};

export const getFilterParameters = () => {
	return localStorage.getItem("campaignsFilter");
};
